export default {
    error: {
        FIX_ALL_ERRORS: "please, fix all errors and save again",
        CONNECTION_TO_THE_SERVER: "could not connect to the server, check your network and try again",
        UNKNOWN_ERROR: "error to save the form, try again",
        REQUIRED_FIELD: "this field is required",

        INVALID_REQUEST: "invalid request",
        INTERNAL_SERVER_ERROR: "internal server error",
        RECAPTCHA_ERROR: "recaptcha token is invalid, are you a bot?",

        COMPANY_NOT_FOUND: "company code not found",
        INCORRECT_USERNAME_PASSWORD: "incorrect username or password",
        BANNED_USER: "your access is temporarily blocked",
    },
    auth_login: {
        company_code: "Company code",
        username: "Username",
        password: "Password",
        proceed: "PROCEED",
        sign_in: "SIGN IN",
        loading: "LOADING...",
        forgot_password: "Forgot password?",
        privacy_policy: "Privacy Policy",
        privacy_policy_link: "https://policies.google.com/privacy",
        terms_of_service: "Terms of Service",
        terms_of_service_link: "https://policies.google.com/terms",
        recaptcha_warning: "This site is protected by reCAPTCHA and the Google {{0}} and {{1}} apply."
    },
    common: {
        failed_retrieve_data_from_server: "Failed to retrieve data from server.",
        try_again: "Try again",
        save_button: "Save",
        saving: "Saving...",
        edit_button: "Edit",
        loading: "Loading...",
        refresh_data: "Refresh data",
        delete_button: "Delete",
        deleting: "Deleting...",
    },
    breadcrumbs: {
        '404_error': '404 Error',
        login: 'Login',
        forgot_password: 'Forgot password',
        home: 'Foodsoft',
        dashboard: 'Dashboard',
        order_listing: 'Orders',
        menu_listing: 'Menus',
        menu_form_new: 'New menu',
        menu_form_edit: 'Configure menu',
        product_listing: 'Products',
        product_form_new: 'New product',
        product_form_edit: 'Edit product',
        product_category_form_new: 'New category',
        product_category_form_edit: 'Edit category',
        general_settings_form: 'General settings',
        store_listing: 'Stores',
        store_form_new: 'New store',
        store_form_edit: 'Edit store',
        staff_member_listing: 'Staff members',
        staff_member_form_new: 'New staff member',
        staff_member_form_edit: 'Edit staff member',
        role_listing: 'Roles',
        role_form_new: "New role",
        role_form_edit: "Edit role",
        reports_listing: "Reports",
        product_sales: "Product sales"
    },
    navigation: {
        dashboard: "Dashboard",
        orders: "Orders",
        menus: "Menus",
        reports: "Reports",
        product_sales: "Product sales",
        visit_website: "Visit your website",
        settings: "Settings",
        company_data: "Company data",
        general_settings: "General settings",
        manage_stores: "Manage stores",
        manage_staff: "Manage staff",
        manage_roles: "Manage roles",
        user: "User",
        my_data: "My data",
        logout: "Logout",
        help: "Help",
    },
    state: {
        loading_message: "Loading...",
        empty_message: "No results found",
        request_error_message: "Failed to retrieve data from server",
        try_again: "Try again",
    },
    footer: {
        copyright: "Copyright © {{age}} Stomp Technology.",
    },
    not_found: {
        page_unavailable: "Sorry, this page isn't available.",
        link_broken: "The link you followed may be broken, or the page may have been removed.",
        go_to_dashboard_link: "Go back to dashboard",
    },
    input_image: {
        select_file: "Select file",
        browse: "Browse",
        image_remove_btn: "Remove",
        adjust_image: "Adjust image",
        ok_btn: "OK",
        rotate_90: "Rotate 90º",
        rotate_90_invert: "Rotate -90º",
    },
    general_settings: {
        display_name: "Display name",
        display_name_warning: "",
        company_code: "Company code",
        company_code_warning: "The company code is part of the address of your online menu and is also necessary for you to log in to the system.",
        logo: "Logo",
        logo_description: "Upload your logo with 512x512 pixels or higher",
        language_code: "Language",
        "pt-BR": "Portuguese (brazilian)",
        "en-US": "English",
        country_code: "Country",
        BR: "Brazil",
        US: "United States",
        facebook_link: "Facebook",
        instagram_link: "Instagram",
        themes: "Themes",
        theme_choose: "Choose",
        facebook_pixel_id: "Facebook Pixel (apenas o ID)",
        facebook_pixel_id_description: "The Facebook pixel is an analysis tool that allows you to measure the effectiveness of your advertising based on the actions that people take on your website.",
        timezone: "Timezone",
        timezone_description: ""
    },
    printer_settings: {
        printer: "Printer",
        printer_description: "Compatible with thermal printers only",
        have_guillotine: "Does the printer have a guillotine?",
        cut_paper_yes: "Yes",
        cut_paper_no: "No",
        failed_retrieve_printers: "Failed to load thermal printers.",
        connection: "Connection",
        printer_adapter_navigatorusb: "USB (compatible navigators)",
        printer_adapter_printerws: "Printer Connect",
    },
    store_listing: {
        new_button: "New store",
        delete_store_confirm: "Are you sure you want to permanently delete the \"{{name}}\" store?"
    },
    store_form: {
        name: "Store nome",
        menu: "Menu",
        phone: "WhatsApp",
        store_code: "Store code",
        warning_store_code: "This code will be part of the store link, but will only be visible if there are two or more registered stores.",
        preparation_time: "Preparation time",
        preparation_time_append_text: "minutes",
        preparation_time_description: "Fill this field in minutes",
        accept_delivery_order: "Accept delivery order",
        accept_delivery_order_yes: "Yes",
        accept_delivery_order_no: "No",
        accept_pickup_order: "Accept pickup order",
        accept_pickup_order_yes: "Yes",
        accept_pickup_order_no: "No",
        payment_methods: "Payment methods",
        payment_methods_options: "Options",
        payment_method_add: "Add",
        payment_method_remove: "Remove",
        payment_method_price_change_option: "Price change",
        payment_method_price_change_option_no_change: "No change in price",
        payment_method_price_change_option_fixed_discount: "Fixed discount",
        payment_method_price_change_option_percentage_discount: "Percentage discount",
        payment_method_price_change_option_fixed_increase: "Fixed increase",
        payment_method_price_change_option_percentage_increase: "Percentage increase",
        payment_method_name: "Payment method",
        payment_method_ask_need_change: "Ask if need change",
        payment_method_ask_need_change_no: "No",
        payment_method_ask_need_change_yes: "Yes",
        payment_method_fixed_price_increase: "Amount",
        payment_method_percentage_price_increase: "Percent",
        delivery_fee: "Delivery fee",
        delivery_fee_type: "Options",
        FIXED: "Fixed",
        TO_BE_NEGOTIATED: "To be negotiated",
        BY_NAMED_AREA: "By Neighborhood",
        delivery_fee_fixed: "Fee",
        delivery_named_areas: "Neighborhoods",
        delivery_named_area_name: "Name",
        delivery_named_area_price: "Fee",
        delivery_named_area_add: "Add",
        delivery_named_area_remove: "Remove",
        free_delivery_starting_from: "Free delivery starting from",
        free_delivery_starting_from_description: "Fill with zero if you don't want to offer free delivery",
        minimum_order_value: "Minimum order value",
        address: "Address",
        address_line1: "Street Address",
        address_house_number: "House number",
        address_line2: "Additional Information",
        address_level3: "Neighborhood",
        postal_code: "Postal code",
        address_level2: "City",
        address_level1: "State/Province",
        opening_hours: "Opening hours",
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        opening_hours_from: "Opens at",
        opening_hours_to: "Closes at",
        opening_hours_add: "Add",
        opening_hours_remove: "Remove"
    },
    role_listing: {
        new_button: "New role",
        status: "Status",
    },
    role_form: {
        name: "Name",
        permissions: "Permissions",
    },
    role_permissions: {
        roles: "Roles",
        view_roles: "View roles",
        edit_roles: "Edit roles",
        staff_members: "Staff members",
        view_staff_members: "View staff members",
        edit_staff_members: "Edit staff members",
        products: "Products",
        view_products: "View products",
        edit_products: "Edit products",
        product_categories: "Product Categories",
        view_product_categories: "View product categories",
        edit_product_categories: "Edit product categories",
        company: "Company",
        view_company: "View company",
        edit_company: "Edit company",
        view_stores: "View stores",
        edit_stores: "Edit stores"
    },
    staff_member_listing: {
        new_button: "New member",
        role: "Role",
        error_load_roles: "Error to load roles",
        all_roles: "All roles",
        search: "Search",
        search_placeholder: "Tax number or e-mail",
        search_button: "Search",
        ban_button: "Ban",
        banning: "Banning...",
        revoke_ban_button: "Revoke ban",
        revoking_ban: "Revoking...",
        status: "Status",
        status_banned: "Banned",
        status_not_banned: "Active",
    },
    staff_member_form: {
        name: "Name",
        role: "Role",
        tax_number: "Tax number",
        birth_date: "Birth date",
        email: "E-mail",
        phone: "Phone",
        username: "Username",
        new_password: "New password",
        note: "Note",
        note_description: "You can enter additional information here",
        validation_password_required: "password is required if you are creating a username",
    },
    product: {
        choice_type_options_multiple_choice: "Multiple choice options",
        choice_type_options_single_choice: "Single choice options",
        choice_type_options_repeatable_choice: "Repeatable choice options",
        choice_type_text: "Text",
    },
    product_listing: {
        new_category_button: "New category",
        new_product_button: "New product",
        reorder_categories: "Reorder categories",
        reorder_categories_ok: "Save order",
        reorder_categories_saving: "Saving...",
        reorder_products: "Reorder products",
        reorder_ok: "OK",
        reorder_saving: "Saving...",
        edit_category: "Edit category",
        delete_category: "Delete category",
        product_status: "Status",
        status_disabled: "Disabled",
        status_enabled: "Enabled",
        enable_button: "Enable",
        enabling: "Enabling...",
        disable_button: "Disable",
        disabling: "Disabling...",
        delete_product_category_confirm: "Are you sure you want to permanently delete the \"{{name}}\" category?",
        delete_product_confirm: "Are you sure you want to permanently delete the \"{{name}}\" product?",
        clone_button: "Clone",
        cloning: "Cloning...",
        cloned_product_suffix: " (copy)"
    },
    product_form: {
        name: "Name",
        product_category: "Category",
        price: "Price",
        photo: "Photo",
        photo_description: "Upload an image with 592x333 pixels or higher",
        description: "Description",
        description_details: "Describe the product in detail to help consumers choose",
        choices: "Personalized choices",
        choice_empty_title: "Untitled choice",
        reorder_choices: "Reorder choices",
        reorder_choices_ok: "OK",
        choice_add: "Add new choice",
        no_choice_message: "No personalized choice has been created for this product yet.",
        choice_title: "Title",
        choice_type: "Type",
        choice_min_options: "Minimum options",
        choice_max_options: "Maximum options",
        charge_only_most_expensive_option_label: "Billing of options",
        charge_only_most_expensive_option_description: "Applicable when additional price is filled",
        charge_only_most_expensive_option_no: "Add the price of the chosen options (default)",
        charge_only_most_expensive_option_yes: "Charge only the most expensive option chosen",
        choice_required: "Mandatory",
        required: "Required",
        not_required: "Optional",
        choice_note: "Note",
        choice_remove: "Remove choice",
        choice_options: "Options",
        choice_option_empty_description: "Option without description",
        reorder_choice_options: "Reorder options",
        reorder_choice_options_ok: "OK",
        choice_option_add: "Add new option",
        no_choice_option_message: "No option has been created for this choice yet.",
        choice_option_description: "Description",
        choice_option_price: "Additional price",
        choice_option_details: "Details",
        choice_option_remove: "Remove option",
    },
    product_category_form: {
        name: "Name",
    },
    menu_listing: {
        new_button: "New menu",
        edit_button: "Configure",
        products_button: "Edit",
        delete_menu_confirm: "Are you sure you want to permanently delete the \"{{name}}\" menu?"
    },
    menu_form: {
        name: "Menu name"
    },
    order_listing: {
        new_button: "New order",
        store: "Store",
        auto_printing_switch: "Auto printing",
        error_load_stores: "Error to load stores",
        customer_name: "Customer",
        address_level3: "Neighborhood",
        items_count: "Items",
        total: "Total",
        show_order_button: "Show",
        print_order_button: "Print",
        printing: "Printing...",
        PRINTING_ERROR: "Error printing order.",
        sequential_number: "Sequential",
        order_type: "Type",
        order_type_DELIVERY: "Delivery",
        order_type_PICKUP: "Pickup",
        order_header: "Order",
    },
    product_sales_report: {
        product_sales_report: "Product sales report",
        periodicity: "Periodicity",
        daily: "Daily"
    }
}
